var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app",
      class: {
        beta: _vm.isBeta
      },
      attrs: { id: "app" }
    },
    [
      _c(
        "datalist",
        { attrs: { id: "special-tokens" } },
        _vm._l(_vm.specialTokens, function(value, key) {
          return _c("option", { key: key, domProps: { value: key } })
        }),
        0
      ),
      _c("div", { staticClass: "header" }, [
        _c("img", {
          staticClass: "logo",
          attrs: { src: require("./assets/logo.png"), alt: "Vue" }
        }),
        _c(
          "span",
          { staticClass: "message-container" },
          [
            _c("transition", { attrs: { name: "slide-up" } }, [
              _c("span", { key: _vm.message, staticClass: "message" }, [
                _c("span", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.message))
                ]),
                _c("span", { staticClass: "badges" }, [
                  _vm.isBeta
                    ? _c("span", { staticClass: "badge" }, [
                        _vm._v("\n              beta devtools\n            ")
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c(
              "VueGroup",
              {
                staticClass: "primary inline",
                attrs: { indicator: "" },
                model: {
                  value: _vm.routeModel,
                  callback: function($$v) {
                    _vm.routeModel = $$v
                  },
                  expression: "routeModel"
                }
              },
              [
                _c(
                  "VueGroupButton",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.$t("App.components.tooltip"),
                        expression: "$t('App.components.tooltip')"
                      }
                    ],
                    staticClass: "components-tab flat",
                    class: {
                      "icon-button": !_vm.$responsive.wide
                    },
                    attrs: { value: "components", "icon-left": "device_hub" }
                  },
                  [_vm._v("\n          Components\n        ")]
                ),
                _c(
                  "VueGroupButton",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.$t("App.vuex.tooltip"),
                        expression: "$t('App.vuex.tooltip')"
                      }
                    ],
                    staticClass: "vuex-tab flat",
                    class: {
                      "icon-button": !_vm.$responsive.wide
                    },
                    attrs: { value: "vuex", "icon-left": "restore" }
                  },
                  [_vm._v("\n          Vuex\n        ")]
                ),
                _c(
                  "VueGroupButton",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.$t("App.events.tooltip"),
                        expression: "$t('App.events.tooltip')"
                      }
                    ],
                    staticClass: "events-tab flat big-tag",
                    class: {
                      "icon-button": !_vm.$responsive.wide
                    },
                    attrs: {
                      tag: _vm.newEventCount > 0 ? _vm.newEventCount : null,
                      value: "events",
                      "icon-left": "grain"
                    },
                    nativeOn: {
                      focus: function($event) {
                        _vm.isRouterGroupOpen = false
                      }
                    }
                  },
                  [_vm._v("\n          Events\n        ")]
                ),
                _c(
                  "GroupDropdown",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.left",
                        value: _vm.$t("App.routing.tooltip"),
                        expression: "$t('App.routing.tooltip')",
                        modifiers: { left: true }
                      }
                    ],
                    attrs: {
                      "is-open": _vm.isRouterGroupOpen,
                      options: _vm.routingTabs,
                      value: _vm.routeModel
                    },
                    on: {
                      update: function($event) {
                        _vm.isRouterGroupOpen = $event
                      },
                      select: function($event) {
                        _vm.routeModel = $event
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "option",
                        fn: function(ref) {
                          var option = ref.option
                          return [
                            _c(
                              "VueGroupButton",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.left",
                                    value:
                                      !_vm.$responsive.wide && option.label,
                                    expression:
                                      "!$responsive.wide && option.label",
                                    modifiers: { left: true }
                                  }
                                ],
                                staticClass: "router-tab flat big-tag",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  value: option.name,
                                  "icon-left": option.icon
                                },
                                on: {
                                  selected: function($event) {
                                    _vm.isRouterGroupOpen = false
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(option.label) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  },
                  [
                    _c(
                      "template",
                      { slot: "header" },
                      [
                        _c("VueIcon", {
                          staticClass: "left-icon",
                          attrs: { icon: "directions" }
                        }),
                        _c("span", { staticClass: "hide-below-wide" }, [
                          _vm._v("\n              Routing\n            ")
                        ]),
                        _c("VueIcon", {
                          staticClass: "right-icon",
                          attrs: { icon: "keyboard_arrow_down" }
                        })
                      ],
                      1
                    )
                  ],
                  2
                ),
                _c(
                  "VueGroupButton",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.$t("App.perf.tooltip"),
                        expression: "$t('App.perf.tooltip')"
                      }
                    ],
                    staticClass: "perf-tab flat",
                    class: {
                      "icon-button": !_vm.$responsive.wide
                    },
                    attrs: { value: "perf", "icon-left": "assessment" }
                  },
                  [_vm._v("\n          Performance\n        ")]
                ),
                _c(
                  "VueGroupButton",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.$t("App.settings.tooltip"),
                        expression: "$t('App.settings.tooltip')"
                      }
                    ],
                    staticClass: "settings-tab flat",
                    class: {
                      "icon-button": !_vm.$responsive.wide,
                      info: _vm.hasNewSettings
                    },
                    attrs: {
                      tag: _vm.hasNewSettings ? "new" : null,
                      value: "settings",
                      "icon-left": "settings_applications"
                    },
                    nativeOn: {
                      focus: function($event) {
                        _vm.isRouterGroupOpen = false
                      }
                    }
                  },
                  [_vm._v("\n          Settings\n        ")]
                )
              ],
              1
            ),
            _c(
              "VueButton",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.$t("App.refresh.tooltip"),
                    expression: "$t('App.refresh.tooltip')"
                  }
                ],
                ref: "refresh",
                staticClass: "refresh-button flat",
                class: {
                  "icon-button": !_vm.$responsive.wide
                },
                attrs: { "icon-left": "refresh" },
                on: { click: _vm.refresh }
              },
              [_vm._v("\n        Refresh\n      ")]
            )
          ],
          1
        )
      ]),
      _c("router-view", { staticClass: "container" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }